"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlocksEnteredScreenCard = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BlockTypeDisplayMappings_1 = require("Analytics/Page/BlockTypeDisplayMappings");
var BlocksEnteredScreenCard = function (_a) {
    var interactionEventData = _a.interactionEventData;
    var isSingleEvent = interactionEventData.blocks.length === 1;
    var headingText = isSingleEvent ? "Block Entered Screen" : "Blocks Entered Screen";
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
        react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "5", align: "left" }, headingText),
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs" }, interactionEventData.blocks.map(function (b, index) {
            var Icon = (0, BlockTypeDisplayMappings_1.getBlockIcon)(b.blockType);
            return (react_1.default.createElement(kaleidoscope_1.Stack, { key: index, direction: "horizontal", align: "center", gap: "s" },
                Icon !== null && react_1.default.createElement(Icon, { color: "default" }),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, b.blockName)));
        }))));
};
exports.BlocksEnteredScreenCard = BlocksEnteredScreenCard;
